import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from './LocationContext';
import './Places.css'
import { InputText } from 'primereact/inputtext';
import { Tooltip } from 'primereact/tooltip';

function Places({ lat, lon }) {

    const { location, setLocation } = useLocation()
    const [name, setName] = useState()
    const autoCompleteRef = useRef();
    const inputRef = useRef();
    const options = {
        componentRestrictions: { country: "ng" },
        fields: ["address_components", "geometry", "icon", "name"],
        types: ["establishment"]
    };

    useEffect(() => {
        // Coloca aquí el código del mapa
        async function initMap() {
            const { Map } = await window.google.maps.importLibrary('maps');
            const { SearchBox } = await window.google.maps.importLibrary("places")
            autoCompleteRef.current = new window.google.maps.places.Autocomplete(
                inputRef.current,
                options
            );
            // const { AdvancedMarkerElement } = await window.google.maps.importLibrary('marker');
            console.log(lat, lon)
            const map = new Map(document.getElementById('map'), {
                zoom: 10,
                center: {
                    lat: lat,
                    lng: lon,
                },
                mapId: process.env.REACT_APP_MAPS
            });

            let request = {
                location: map.getCenter(),
                radius: 200,
            };

            function callback(results, status) {
                if (status == window.google.maps.places.PlacesServiceStatus.OK) {
                    let firstPlace = results[0]
                    setName(firstPlace.name)
                }
            }

            const service = new window.google.maps.places.PlacesService(map);
            service.nearbySearch(request, callback)

            // Create the search box and link it to the UI element.
            const input = document.getElementById("pac-input");
            const searchBox_ = new SearchBox(input);

            let marker1 = new window.google.maps.Marker({
                map,
                title: "Vas a marcar aquí",
                position: map.getCenter()
            })

            map.controls[window.google.maps.ControlPosition.TOP_CENTER].push(input);
            // Bias the SearchBox results towards current map's viewport.
            map.addListener("bounds_changed", () => {
                searchBox_.setBounds(map.getBounds());
            });

            map.addListener("center_changed", () => {
                searchBox_.setBounds(map.getBounds());
            });

            let markers = []


            searchBox_.addListener("places_changed", () => {
                const places = searchBox_.getPlaces();

                if (places.length == 0) {
                    return;
                }

                marker1.setMap(null)
                // Clear out the old markers.
                markers.forEach((marker) => {
                    marker.setMap(null);
                });
                markers = [];

                // For each place, get the icon, name and location.
                const bounds = new window.google.maps.LatLngBounds();

                console.log(places)

                places.forEach((place) => {
                    if (!place.geometry || !place.geometry.location) {
                        console.log("Returned place contains no geometry");
                        return;
                    }

                    const icon = {
                        url: place.icon,
                        size: new window.google.maps.Size(71, 71),
                        origin: new window.google.maps.Point(0, 0),
                        anchor: new window.google.maps.Point(17, 34),
                        scaledSize: new window.google.maps.Size(25, 25),
                    };

                    // Create a marker for each place.
                    markers.push(
                        new window.google.maps.Marker({
                            map,
                            icon,
                            title: place.name,
                            position: place.geometry.location,
                        }),
                    );
                    setLocation(place.geometry.location)
                    if (place.geometry.viewport) {
                        // Only geocodes have viewport.
                        bounds.union(place.geometry.viewport);
                    } else {
                        bounds.extend(place.geometry.location);
                    }
                });
                map.fitBounds(bounds);
            });
        }

        // Llama a la función de inicialización del mapa
        initMap();

        // Agrega la limpieza del mapa si es necesario
        return () => {
            // Limpiar el mapa o realizar otras acciones de limpieza si es necesario
        };
    }, []);

    return (
        <div className='w-full'>
            <Tooltip target=".info" className='indigo-tooltip ml-1' />
            <InputText
                id="pac-input"
                className="controls"
                type="text"
                placeholder={name}
                style={{ width: '20rem' }}
            // ref={inputRef}
            />
            <div id="map" style={{ height: '70vh', width: '55vw' }} />
        </div>
    )
}

export default Places